/**
 * FILE: apps/hub/src/pages/NotFound.tsx
 * PURPOSE: Hub page component.
 * AGENT_CONTEXT: Route-level component. Lazy-load if >200 lines expected.
 * INVARIANTS: Use QK.* query keys, useActor() for writes, theme tokens only.
 * LAST_REVIEWED: 2026-05-07
 */

import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/useAuth'
import { defaultPathByPermissions } from '@/lib/authz'

export function NotFoundPage() {
  const { identity } = useAuth()
  const home = identity
    ? defaultPathByPermissions(identity.permissions, identity.roleName)
    : '/login'

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4">
      <h1 className="text-2xl font-semibold text-foreground">Page not found</h1>
      <p className="text-sm text-muted-foreground">The route you are looking for does not exist.</p>
      <Button asChild>
        <Link to={home}>Go home</Link>
      </Button>
    </div>
  )
}
